<template>
  <div>
    <div class="order-filter-card">
      <el-form :inline="true" :model="searchForm" class="filter-form">
        <el-form-item>
          <!-- <el-button type="primary" @click="getData" size="small">查询</el-button>
          <el-button @click="resetForm" size="small">重置</el-button> -->
          <!-- 新增：提取说明按钮，放在红圈位置 -->
          <el-button type="info" @click="openExtractTip" size="small">提取说明</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="order-table-area">
      <el-table class="order-table" :data="dataSource" style="width: 100%" empty-text="暂无数据">

        <!-- <el-table-column prop="order_name" label="套餐内容" min-width="180" align="center" /> -->
        <el-table-column prop="order_sn" label="套餐号" min-width="180" align="center" />

        <el-table-column prop="status" label="订单状态" min-width="130" align="center">
          <template #default="{ row }">
            <!-- 0 未成功 -->
            <span v-if="row.status == 0" style="color:#909399;">未成功</span>
            <!-- 1 成功 -->
            <span v-else-if="row.status == 1" style="color:#67c23a;">已激活</span>
            <!-- 2 过期 -->
            <span v-else-if="row.status == 2" style="color:#F56C6C;">已过期</span>
            <!-- 3 用户取消订阅 -->
            <span v-else-if="row.status == 3" style="color:#F56C6C;">已取消订阅</span>
            <!-- 4 付款失败 -->
            <span v-else-if="row.status == 4" style="color:#F56C6C;">付款失败</span>
            <!-- 5 取消订阅待处理 -->
            <span v-else-if="row.status == 5" style="color:#E6A23C;">取消待处理</span>
            <!-- 6 权限/套餐更新 -->
            <span v-else-if="row.status == 6" style="color:#409EFF;">套餐更新中</span>
            <!-- 其他 -->
            <span v-else style="color:#909399;">未知状态</span>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="激活时间" min-width="160" align="center">
          <template #default="{ row }">
            <span>{{ formatTime(row.create_time) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="op" label="操作" min-width="180" align="center" fixed="right">
          <template #default="{ row }">
            <!-- <el-button type="text" @click="submitInvoice(row)" v-if="!row.invoice">开票</el-button> -->
            <el-button type="text" v-if="row.status == 1" @click="getOrderDetails(row)">套餐详情</el-button>

          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination @current-change="pageChange" :page-size="5" background layout="total,prev, pager, next"
        :total="total" />
    </div>
    <Dialog title="套餐详情" ref="orderDetails" width="1000px">
      <div>
        <el-descriptions :column="2" border>
          <el-descriptions-item label="订单编号">{{ orderDetails.order_sn }}</el-descriptions-item>
          <el-descriptions-item label="账号">{{ orderDetails.username }}</el-descriptions-item>
          <!-- <el-descriptions-item label="套餐内容">{{ orderDetails.order_name }}</el-descriptions-item> -->
          <!-- <el-descriptions-item label="套餐地区">
            <el-tag type="danger" size="small">国外</el-tag>
          </el-descriptions-item> -->
          <el-descriptions-item label="会话时长" v-if="orderDetails.validity_minutes != 0">
            {{ orderDetails.validity_minutes }}分钟
          </el-descriptions-item>
          <!-- <el-descriptions-item label="当天提取数量">
            {{ orderDetails.day_use_num }}个
          </el-descriptions-item> -->
          <!-- <el-descriptions-item label="已使用IP数量">
            {{ orderDetails.ip_use_num }}个
          </el-descriptions-item> -->
          <!-- <el-descriptions-item label="提取记录">
            <el-button type="text" @click.stop.prevent="getUseLogList">查看</el-button>
          </el-descriptions-item> -->
          <el-descriptions-item label="流量上限">
            {{ limit }}
          </el-descriptions-item>
          <el-descriptions-item label="已使用流量" v-if="orderDetails.ini_liuliang == 0">
            {{ used }}
          </el-descriptions-item>
          <el-descriptions-item label="套餐有效时间" v-if="orderDetails.duration_days > 0">
            {{ orderDetails.price_type == 0 ? orderDetails.duration_days + '天' : '不限' }}
          </el-descriptions-item>
          <el-descriptions-item label="套餐过期时间" v-if="orderDetails.duration_days > 0">
            {{ orderDetails.validity_day }}
          </el-descriptions-item>
          <el-descriptions-item label="密钥">
            <div style="display: flex;justify-content: space-between;align-items: center">
              <span>{{ orderDetails.password }}</span>
              <el-button type="text" @click.stop="resToken">重置</el-button>
            </div>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <el-descriptions title="白名单" style="margin-top: 20px" v-if="orderDetails.aws_order_type != 0">
        <template #title>
          <h5>白名单</h5>
        </template>
        <template #extra>
          <h5>
            <el-button type="text" @click="() => { $refs.addWhitelistRef.onOpen() }">操作白名单</el-button>
          </h5>
        </template>
      </el-descriptions>
      <el-input type="textarea" disabled v-model="orderDetails.white_list"
        v-if="orderDetails.aws_order_type != 0"></el-input>
      <span slot="btn" style="display: flex;justify-content: center;margin-top: 10px;">
        <el-button size="small" @click="$refs.orderDetails.onClose()">关闭</el-button>
      </span>
    </Dialog>
    <Dialog title="操作白名单" ref="addWhitelistRef" width="400px">
      <el-form :model="addWhitelistForm" label-width="60px" size="small">
        <el-form-item label="IP">
          <el-input v-model="addWhitelistForm.ip" placeholder="请输入IP" size="small" />
        </el-form-item>
        <el-form-item label="备注">
          <el-radio-group v-model="addWhitelistForm.op">
            <el-radio label="add">添加</el-radio>
            <el-radio label="del">删除</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="btn" style="display: flex;align-items: center;justify-content: center">
        <div>
          <el-button size="small" @click="$refs.addWhitelistRef.onClose()">取消</el-button>
          <el-button type="primary" size="small" @click="submitAddWhitelist">提交</el-button>
        </div>
      </div>
    </Dialog>
    <Dialog title="提取记录" ref="useLog" width="1000px">
      <el-table :data="useLogList" v-loading="opLoading" height="500px"
        style="width: 100%; margin-bottom: 16px; font-size: 14px;" size="small">
        <el-table-column label="地区" prop="res" align="center" />
        <el-table-column label="提取格式" prop="fmt" align="center" />
        <el-table-column label="换行格式" prop="sp" align="center" />
        <el-table-column label="操作IP" prop="operate_ip" align="center" />
        <el-table-column label="提取的IP数量" prop="use_num" align="center" />
        <el-table-column label="提取状态" prop="status" align="center">
          <template #default="scope">
            <span v-if="scope.row.status == 1" style="color:#67c23a;">成功</span>
            <span v-else style="color:#f56c6c;">失败</span>
          </template>
        </el-table-column>
        <el-table-column label="提取时间" prop="createtime" align="center" />
      </el-table>
      <div class="pagination mt20">
        <el-pagination @current-change="(e) => { searchLogForm.page = e; getUseLogList }" background
          layout="total, prev, pager, next" :total="searchLogForm.total" :page-size="15" />
      </div>
      <span slot="btn" style="display: flex;justify-content: center">
        <el-button size="small" @click="$refs.useLog.onClose(); logLoading = true">关闭</el-button>
      </span>
    </Dialog>
    <Dialog title="代理使用说明 & 提取URL" ref="getExtractUrl" width="1200px">
      <!-- 滚动区域 -->
      <div style="max-height: 500px; overflow-y: auto; padding-right: 10px;">
        <!-- 代理使用说明 -->
        <div style="font-size: 13px; line-height: 1.7;">
          <div style="font-weight: bold; margin-bottom: 8px; font-size: 14px;">概述：</div>
          <div>本文档介绍了帐密的使用方法和操作说明，</div>
          <div>支持协议：socks5, http, https</div>

          <div style="height: 1px; background: #eee; margin: 12px 0;"></div>

          <div style="font-weight: bold; margin-bottom: 8px;">1.1 帐密使用说明：</div>
          <div>服务器地址：tdproxy.ppfly.xyz</div>
          <div>端口：1080</div>
          <div>密码：密钥</div>
          <div>帐号：订单编号</div>

          <div style="margin-top: 8px;">
            <div style="font-weight: bold;">账号说明示例：</div>
            <div>XXXX-res-US-session-1000-sessTime-8</div>
            <div>XXXX 账号</div>
            <div>res-US 指定地区，US 国家代码，不指定时随机</div>
            <div>session-1000 1~12位随机数字</div>
            <div>sessTime-8 每个session保留时间，单位分钟，不填时保留3分钟，时间范围为3-30</div>
          </div>

          <div style="height: 1px; background: #eee; margin: 12px 0;"></div>

          <div style="font-weight: bold; margin-bottom: 8px;">1.2 调用示例：</div>
          <div>示例：获取一个美国session,有效时间8分钟：</div>
          <div
            style="background: #f5f5f5; padding: 6px 8px; border-radius: 4px; margin: 4px 0; font-family: monospace;">
            curl -x tdproxy.ppfly.xyz:1080 -U XXXXX-res-US-session-10001121-sessTime-8:XXXXX cip.cc
          </div>
          <div>随机获取一个session,有效时间3分钟：</div>
          <div
            style="background: #f5f5f5; padding: 6px 8px; border-radius: 4px; margin: 4px 0; font-family: monospace;">
            curl -x tdproxy.ppfly.xyz:1080 -U XXXXX-session-100123120:XXXXXX cip.cc
          </div>

          <div style="height: 1px; background: #eee; margin: 12px 0;"></div>

          <!-- 国家编码列表 -->
          <div style="font-weight: bold; margin-bottom: 8px;">国家编码对照表：</div>
          <div style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 4px; font-size: 12px;">
            <div v-for="item in countryList" :key="item.code">
              {{ item.code }} - {{ item.area_name }}
            </div>
          </div>
        </div>
      </div>
      <span slot="btn" style="display: flex;justify-content: center">
        <el-button size="small" @click="$refs.getExtractUrl.onClose(); logLoading = true">关闭</el-button>
      </span>
    </Dialog>
  </div>
</template>

<script>

import Dialog from "@/components/Dialog.vue";


export default {
  name: 'Index',
  components: { Dialog },
  data() {
    return {
      extractUrl: '',
      areas: [],
      whitelist: [],
      order_sn: '',
      extractForm: {
        order_sn: '',
        res: '',
        fmt: '',
        sp: '',
        total: 1,

      },
      dataSource: [],
      total: 0,
      searchForm: {
        page: 1,
        order_sn: '',
        ip_type: '',
        price_type: ''
      },
      orderDetails: {},

      orderDetail: null,
      showToken: false,
      addWhitelistForm: {
        ip: '',
        op: '',
      },
      searchLogForm: {
        order_sn: '',
        page: 1,
        total: 0,
      },
      opLoading: false,
      useLogList: [],
      used: '0',
      limit: '0',
      countryList: [],


    }
  },
  created() {
    this.getData()
  },
  methods: {
    // 新增：打开提取说明弹窗的方法
    openExtractTip() {
      this.$api.awsOrder.getCountryList().then(res => {
        this.countryList = res.data;
        this.$refs.getExtractUrl.onOpen();
      });

    },
    generateUrl() {
      this.$api.awsOrder.generateUrl(this.extractForm).then(res => {
        this.extractUrl = res.data
      });
    },
    getAreas(row) {
      this.$refs.getExtractUrl.onOpen();

    },
    onLogPageChange(page) {
      this.searchLogForm.page = page;
      this.getWhilteListLog({ order_sn: this.searchLogForm.order_sn });
    },
    getUseLogList() {
      this.searchLogForm.order_sn = this.orderDetails.order_sn
      this.$api.awsOrder.extractLogList(this.searchLogForm).then(res => {
        this.useLogList = res.data.list
        this.searchLogForm.total = res.data.total
        this.$refs.useLog.onOpen()
        this.opLoading = false
      })
    },
    resToken() {
      this.$confirm('你确定要重置密钥吗?').then(() => {
        this.$api.awsOrder.resToken({ order_sn: this.orderDetails.order_sn }).then(() => {
          this.$message.success('重置成功')
          this.getOrderDetails(this.orderDetails)
        })
      }).catch(() => {

      })
    },
    getOrderDetails(row) {
      this.$api.awsOrder.packageDetails({ order_sn: row.order_sn }).then(res => {
        this.orderDetails = res.data.order;
        this.used = res.data.used;
        this.limit = res.data.limit;
        this.$refs.orderDetails.onOpen()



      })
    },
    submitInvoice(row) {
      this.$prompt('请输入开票发送的邮箱', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        inputErrorMessage: '邮箱格式不正确'
      }).then(({ value }) => {
        this.$api.invoice.submitInvoice({ email: value, order_sn: row.order_sn }).then(res => {
          if (res.code === 1) {
            this.$message.success(res.msg)
            this.getData()
          }
        }).finally(() => {

        })
      }).catch(() => {
      });

    },
    pageChange(e) {
      this.searchForm.page = e
      this.getData()
    },
    getData() {
      this.$api.awsOrder.getList(this.searchForm).then(res => {
        this.dataSource = res.data.list
        this.total = res.data.total
      })
    },
    resetForm() {
      this.searchForm = { page: 1, order_sn: '', ip_type: '', price_type: '' };
      this.getData();
    },
    showOrderDetail(row) {
      this.showOrderDetailDialog = true;
      this.showOrderDetailLoading = true;
      this.orderDetail = null;
      this.showToken = false;
      this.$api.order.getOrderDetail({
        id: row.id
      }).then(res => {
        this.orderDetail = res.data;
        this.showOrderDetailLoading = false;
      }).catch(() => {
        this.showOrderDetailLoading = false;
      });
    },
    showWhitelist(row) {
      this.showWhitelistDialog = true;
      this.whitelistOrderSn = row.order_sn;
      this.whitelistInput = '';
      this.getWhitelist();
    },
    getWhitelist() {
      this.whitelistLoading = true;
      this.$api.order.getWhitelist({ order_sn: this.whitelistOrderSn }).then(res => {
        this.whitelist = res.data.ip_white_list || [];
        this.whitelistLoading = false;
      }).catch(() => {
        this.whitelistLoading = false;
      });
    },
    submitAddWhitelist() {
      if (!this.addWhitelistForm.ip) {
        this.$message.warning('请输入IP');
        return;
      }
      // IP格式校验
      const ipReg = /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/;
      if (!ipReg.test(this.addWhitelistForm.ip)) {
        this.$message.warning('请输入正确的IP地址');
        return;
      }
      this.$api.awsOrder.opWhiteList({
        order_sn: this.orderDetails.order_sn,
        ip: this.addWhitelistForm.ip,
        remark: this.addWhitelistForm.remark,
        op: this.addWhitelistForm.op
      }).then(() => {
        this.$message.success('添加成功');
        this.addWhitelistForm.ip = '';
        this.addWhitelistForm.remark = '';
        this.showAddWhitelistDialog = false;
        this.getWhitelist();
      });
    },
    deleteWhitelist(row) {
      this.$confirm(`确定要删除此白名单IP吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.awsOrder.opWhiteList({ ip: row.white_ip, 'id': row.id, 'op': 'del', order_sn: row.order_sn }).then(() => {
          this.$message.success('删除成功');
          this.getWhitelist();
        });
      });
    },
    formatTime(ts) {
      if (!ts) return '-';
      // 支持10位和13位时间戳
      const t = ts.toString().length === 10 ? ts * 1000 : ts;
      const d = new Date(t);
      return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}:${d.getSeconds().toString().padStart(2, '0')}`;
    },
    closeOrderDetailDialog() {
      this.showOrderDetailDialog = false;
      this.showToken = false;
    },


  }
}
</script>

<style scoped>
.order-filter-card {
  background: #fff;
  box-shadow: 0 4px 24px rgba(38, 130, 255, 0.08);
  padding: 24px 24px 0 24px;
  margin-top: 20px;
}


.order-table-area {
  min-height: 320px;
  background: #fff;
  margin-top: 0;
  box-shadow: none;
}

.order-table {
  border-radius: 0;
  overflow: hidden;
  box-shadow: none;
}

.order-table ::v-deep tr th {
  background: #f5f7fa;
  color: #222;
  font-weight: 600;
  font-size: 15px;
}

.order-table ::v-deep tr {
  transition: background 0.2s;
}

.order-table ::v-deep tr:hover td {
  background: #f0f7ff;
}

.order-table ::v-deep td,
.order-table ::v-deep th {
  padding: 12px 0;
  height: 48px;
  line-height: 24px;
}

.pagination {
  margin-top: 18px;
  text-align: right;
  padding-bottom: 18px;
}


.el-pagination .el-pager li.active {
  background: #2682ff;
  color: #fff;
  border-radius: 0;
}


.money-strong {
  color: #e67e22;
  font-size: 15px;
}

.order-detail-loading {
  height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.order-detail-loading .el-icon-loading {
  font-size: 32px;
  color: #409EFF;
}

.order-detail-loading .loading-text {
  margin-top: 10px;
  font-size: 14px;
  color: #409EFF;
  letter-spacing: 1px;
}


.pay-select-content {
  padding: 0;
}

.order-info {
  margin-bottom: 30px;
}

.order-info h3 {
  color: #183e7c;
  font-size: 18px;
  margin-bottom: 15px;
  font-weight: 600;
}

.order-item {
  padding: 5px;
}

.item-name {
  color: #2682ff;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
}

.item-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.item-details span {
  color: #666;
  font-size: 14px;
}

.payment-section {
  margin-bottom: 30px;
}

.payment-section h3 {
  color: #183e7c;
  font-size: 18px;
  margin-bottom: 15px;
  font-weight: 600;
}

.payment-options {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
}

.payment-option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: white;
}

.payment-option:hover {
  border-color: #2682ff;
  background: #f8f9ff;
}

.payment-option.active {
  border-color: #2682ff;
  background: #e9efff;
}

.payment-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.payment-name {
  color: #333;
  font-size: 14px;
  font-weight: 500;
}

.order-amount {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.amount-label {
  color: #666;
  font-size: 16px;
  font-weight: 500;
}

.amount-value {
  color: #ff6b35;
  font-size: 24px;
  font-weight: 700;
}
</style>